export default {
  link: {
    label: 'My Summary',
    signInLabel: 'Sign in'
  }
};
